import React from 'react'
import { useLocation } from "react-router-dom";
import ManageEvents from '../ManageEvents'

const AssociatedEvents = (props) => {
    const location = useLocation();
    const pathParts = location.pathname.split("/");
    const profileId = pathParts[2];


    return (
        <div className='manage_events_container p-4'>
            <p className='heading'>Associated Events</p>
            <ManageEvents module={"event-profile"}  {...props} profileId={profileId} />
            <style>{`
            .manage_events_container {
                margin: 0 !important;
                border-radius: 0px;
                background-color: #fff              
            }
            .heading{
                font-family: Hind;
                font-weight: 500;
                font-size: 20px;
                line-height: 40px;
                color: #1E1F24;
            }
        `}</style>
        </div>
    )
}

export default AssociatedEvents